var _defs, _ellipse, _rect, _circle, _circle2, _rect2, _circle3, _rect3, _rect4, _polygon, _rect5, _polygon2, _rect6, _rect7, _line, _line2, _rect8, _rect9, _circle4, _rect10, _rect11, _rect12, _line3, _line4, _line5, _rect13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPropertyHero(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 340 230",
    width: 340,
    height: 230,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "wall",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDE9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "roof",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3D2FA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A1F80"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "glass",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFE9A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC98A"
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 170,
    cy: 212,
    rx: 160,
    ry: 14,
    fill: "rgba(20,10,80,.25)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 196,
    width: 300,
    height: 14,
    rx: 7,
    fill: "#7CD6A8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 176,
    r: 22,
    fill: "#4FBF8B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 186,
    r: 16,
    fill: "#6ED3A0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 186,
    width: 5,
    height: 14,
    fill: "#2E7D5B"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 306,
    cy: 180,
    r: 18,
    fill: "#4FBF8B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 303,
    y: 190,
    width: 5,
    height: 10,
    fill: "#2E7D5B"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 92,
    width: 150,
    height: 106,
    fill: "url(#wall)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "58,96 145,42 232,96",
    fill: "url(#roof)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 122,
    width: 76,
    height: 76,
    fill: "url(#wall)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "212,126 258,98 304,126",
    fill: "url(#roof)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 108,
    width: 40,
    height: 28,
    rx: 3,
    fill: "url(#glass)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 108,
    width: 40,
    height: 28,
    rx: 3,
    fill: "url(#glass)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 108,
    y1: 108,
    x2: 108,
    y2: 136,
    stroke: "#fff",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 182,
    y1: 108,
    x2: 182,
    y2: 136,
    stroke: "#fff",
    strokeWidth: 2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 140,
    width: 122,
    height: 4,
    fill: "#C9C1F5"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 152,
    width: 30,
    height: 46,
    rx: 3,
    fill: "#6C5CE7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 154,
    cy: 176,
    r: 2,
    fill: "#FFE58F"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 156,
    width: 32,
    height: 26,
    rx: 3,
    fill: "url(#glass)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 156,
    width: 32,
    height: 26,
    rx: 3,
    fill: "url(#glass)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 150,
    width: 52,
    height: 48,
    rx: 3,
    fill: "#D9D3FB"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 232,
    y1: 162,
    x2: 284,
    y2: 162,
    stroke: "#C3BAF5",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 232,
    y1: 174,
    x2: 284,
    y2: 174,
    stroke: "#C3BAF5",
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 232,
    y1: 186,
    x2: 284,
    y2: 186,
    stroke: "#C3BAF5",
    strokeWidth: 2
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 190,
    width: 300,
    height: 3,
    fill: "#fff",
    opacity: 0.6
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertyHero);
export default __webpack_public_path__ + "static/media/property-hero.72fff22534805076e8d5838dd3571cc4.svg";
export { ForwardRef as ReactComponent };